import { Tag } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from '../../columns.module.scss';

export type StatusTagInfo = {
  status: 'success' | 'default' | 'warning' | 'error';
  label: string;
  icon?: boolean;
  customIcon?: ReactNode;
};

export const ProcessingStatusTag: FC<{
  statusTagsInfo: StatusTagInfo[];
}> = ({ statusTagsInfo }) => {
  const cx = classnames.bind(styles);
  if (statusTagsInfo.length === 0) {
    return null;
  }

  return (
    <div className={cx('statusTagsContainer')}>
      {statusTagsInfo.map((tagInfo, index) => (
        <Tag
          key={index}
          status={tagInfo.status}
          closable={false}
          outline={false}
          className={cx('statusTag')}
          size='small'
          icon={tagInfo.icon}
          customIcon={tagInfo.customIcon}
        >
          {tagInfo.label}
        </Tag>
      ))}
    </div>
  );
};
